import type { NextPage, GetStaticProps, GetStaticPropsContext } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import FirebaseAuthGuard from '~/components/FirebaseAuthGuard'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import AuthGuard from '~/components/AuthGuard'
import ROUTES from '~/shared/constants/routes.const'
import Metatags from '~/components/Metadata/Metatags'
import { usePageTitle } from '~/utils/tags'
import { StacknLoad } from '~/games/pages/StacknLoad.page'

const StacknLoadPage: NextPage = () => {
  const { t } = useTranslation('games')
  const pageTitle = usePageTitle(t('cranegame.metaTitle'))
  const metaImage = { srcKey: 'meta-images/stackn-load-ogp.png', alt: t('gameTitle') }

  return (
    <>
      <Metatags image={metaImage} metaDescription={t('cranegame.metaDescription')} noindex title={pageTitle} />
      <AuthGuard redirect={ROUTES.STACKNLOAD_LOGIN} redirectQuery={{ from: ROUTES.STACKNLOAD }}>
        <FirebaseAuthGuard hideOnly>
          <StacknLoad />
        </FirebaseAuthGuard>
      </AuthGuard>
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
      ...COMMON_TRANSLATION_MODULE_NAMES,
      'games',
    ])),
  },
})

export default StacknLoadPage
